import React from "react";
import { GlobeAltIcon, MapPinIcon } from "@heroicons/react/24/outline";

export default function BusinessCardProfile({
  name = "John Doe",
  title = "Title",
  company = "Company Name",
  tagline = "Tagline goes here...",
  biography = "Bio goes here...",
  website = "Website.com",
  address = "Address goes here...",
  profileImage = "/placeholder.svg?height=200&width=200",
  logoImage = "/placeholder.svg?height=50&width=50",
  accentColor = "#059669",
  onEvent = () => {},
}) {
  return (
    <div
      className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-3xl shadow-xl max-w-4xl mx-auto overflow-hidden flex flex-col md:flex-row"
      style={{ "--accent-color": accentColor }}
    >
      <div className="w-full md:w-1/3 bg-slate-50 dark:bg-slate-800/50 p-8 border-b md:border-b-0 md:border-r border-slate-200 dark:border-slate-800 flex flex-col items-center text-center">
        <div className="relative mb-6">
          <img
            alt={name}
            className="w-32 h-32 rounded-3xl object-cover border-4 border-white dark:border-slate-700 shadow-xl"
            src={profileImage || "https://picsum.photos/seed/company/400/400"}
            style={{ borderColor: "var(--accent-color)" }}
          />
          <div
            className="absolute -bottom-2 -right-2 text-white w-8 h-8 rounded-full flex items-center justify-center border-4 border-slate-50 dark:border-slate-800"
            style={{ backgroundColor: "var(--accent-color)" }}
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>
        <h2 className="text-2xl font-bold text-slate-900 dark:text-white">{name}</h2>
        <p className="font-semibold text-sm mt-1" style={{ color: "var(--accent-color)" }}>
          {title}
        </p>
        <div className="mt-4 flex flex-col items-center gap-1">
          {logoImage && (
            <img
              src={logoImage}
              alt={company}
              className="w-12 h-12 rounded-xl object-contain"
            />
          )}
          <p className="text-slate-700 dark:text-slate-300 font-semibold">{company}</p>
          {tagline && (
            <p className="text-slate-500 dark:text-slate-400 text-sm italic">{tagline}</p>
          )}
        </div>
      </div>

      <div className="flex-1 p-8 space-y-6">
        <div>
          <h4 className="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest mb-2">
            About {company}
          </h4>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed">
            {biography}
          </p>
        </div>

        <div>
          <h4 className="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest mb-3">
            Contact Information
          </h4>
          <div className="space-y-3">
            {website && (
              <a
                href={website.startsWith("http") ? website : `https://${website}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-sm font-medium text-slate-700 dark:text-slate-300 hover:opacity-80"
                style={{ color: "var(--accent-color)" }}
                onClick={() => onEvent({ action_type: "visit_website", target: "company_website" })}
              >
                <GlobeAltIcon className="w-5 h-5 shrink-0" style={{ color: "var(--accent-color)" }} />
                <span className="truncate">{website.replace(/^https?:\/\//i, "")}</span>
              </a>
            )}
            {address && (
              <div className="flex items-center space-x-3 text-sm font-medium text-slate-700 dark:text-slate-300">
                <MapPinIcon className="w-5 h-5 shrink-0" style={{ color: "var(--accent-color)" }} />
                <span>{address}</span>
              </div>
            )}
            {!website && !address && <span className="text-sm text-slate-500 dark:text-slate-400">—</span>}
          </div>
        </div>
      </div>
    </div>
  );
}
